import Post from './post';
import type { Type } from '@warp-drive/core/types/symbols';
import { hasMany, type AsyncHasMany } from '@warp-drive/legacy/model';
import PostTypes from '@linc-technologies/linced-common/enums/post-type';
import type Media from 'linced-app/models/media';
import type Comment from 'linced-app/models/posts/comment';
import type Reaction from 'linced-app/models/posts/reaction';

// Proto: posts.Post.
export default class Text extends Post {
  declare [Type]: 'posts/text';

  postType = PostTypes.TEXT;

  @hasMany('posts/comment', { async: true, inverse: 'textId' })
  // @ts-expect-error the app models replace the common ones
  // (inverse textId).
  declare comments: AsyncHasMany<Comment>;

  @hasMany('posts/reaction', { async: true, inverse: 'textId' })
  // @ts-expect-error the app models replace the common ones
  // (inverse textId).
  declare reactions: AsyncHasMany<Reaction>;

  // Text posts never attach media, but need their own dedicated inverse
  // (rather than inheriting Post's shared `mediaIds`/`postId`) to satisfy
  // Ember Data's relationship schema validation for this subclass.
  @hasMany('media', { async: true, inverse: 'textId' })
  // @ts-expect-error the app models replace the common ones
  // (inverse textId).
  declare mediaIds: AsyncHasMany<Media>;

  // Don't trigger the Person reloads which the base Post model does.
  reloadPersonOnSave = false;
}
